module.exports = __webpack_public_path__ + "img/edge_divers_coeur.6b1fab5c.svg";